(function () {
	'use strict';

	// load user selector template via webpack
	var userSelectorTemplateUrl = require('../userSelectorDialog/userSelectorDialog.template');

	angular.module('smb-app')
		.directive('smbDocumentContextMenu', DocumentContextMenuDirective)
		.controller('smbDocumentContextMenuController', [
			'$scope',
			'$timeout',
			'$state',
			'$q', 
			'$mdDialog',
			'pxAuthService',
			'sbToastService',
			'smbToolbarService',
			'smbDocumentDataStore',
			'smbStatusDataStore',
			'smbToDoListDataStore',
			'smbDocumentDetailsPanelDataStore',
			'smbDocumentViewerNavigationService',
			'smbDeleteDialogService',
			'gettextCatalog',
			DocumentContextMenuController
		]);

	var templateUrl = require('./documentContextMenu.template');
	function DocumentContextMenuDirective() {
		return {
			restrict: 'E',
			controller: 'smbDocumentContextMenuController',
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: {
				documentId: '@',
				documentTypeId: '@',
				documentGroupId: '@'
			},
			scope: {}
		};
	}

	function DocumentContextMenuController($scope, $timeout,$state, $q, $mdDialog, pxAuthService, sbToastService, smbToolbarService, smbDocumentDataStore, smbStatusDataStore, smbToDoListDataStore, smbDocumentDetailsPanelDataStore, smbDocumentViewerNavigationService, smbDeleteDialogService, gettextCatalog) {
		var vm = this;
		vm.smbToolbarService = smbToolbarService;
		vm.documentDS = smbDocumentDataStore;
		vm.toDoListDS = smbToDoListDataStore;
		vm.detailsPanelDS = smbDocumentDetailsPanelDataStore;

		(function initDocumentContextMenuController() {
			smbDocumentDataStore.loadUserPermissions(vm.documentGroupId)
				.then(function() {
					return smbStatusDataStore.loadStatuses(vm.documentTypeId);
				})
				.then(function getStatusValues() {
					vm.contentStatuses = smbStatusDataStore.contentStatus[0].Constraints.DataSetValues.map(function(sv) {
						var csv = {};
						csv.Label = sv;
						csv.StatusType = 'Content Status';
						return csv; 
					});

					vm.todoStatuses = smbStatusDataStore.todoStatus[0].Constraints.DataSetValues.map(function(sv) {
						var tsv = {};
						tsv.Label = sv;
						tsv.StatusType = 'ToDo Status';
						return tsv; 
					});
					
				})
				.then(function getTagTypeIds() {
					vm.contentStatusTagTypeId = smbStatusDataStore.contentStatus[0].TagTypeId;
					vm.todoStatusTagTypeId = smbStatusDataStore.todoStatus[0].TagTypeId;
					vm.assignedUserIdTagTypeId = smbStatusDataStore.assignedUserId[0].TagTypeId;
					vm.assignedDateTagTypeId = smbStatusDataStore.assignedDate[0].TagTypeId;
				})
				.then(function getDocumentStatusValues() {
					return smbStatusDataStore.getDocumentStatus(vm.documentId);
				})
				.then(function mapDocumentStatusValues(response) {
					vm.documentContentStatusValue = response.filter(function(tt) {
						return tt.TagTypeName.match(/&&_AirBase_Content_Status/);
					})[0].Tags || [];
					vm.documentToDoStatusValue = response.filter(function(tt) {
						return tt.TagTypeName.match(/&&_AirBase_ToDo_Status/);
					})[0].Tags || [];
					vm.documentAssignedUserId = response.filter(function(tt) {
						return tt.TagTypeName.match(/&&_AirBase_Assigned_UserId/);
					})[0].Tags || 0;
				})
				.then(function getUsersList() {
					return smbStatusDataStore.getUsersWithModifyRights(vm.documentId);
				})
				.then(function(userslist) {
					vm.users = userslist.map(function mapusers(u) {
						var user = {};
						user.UserId = u.UserId;
						user.UserName = u.UserName;
						user.EmailAddress = u.EmailAddress;
						return user;
					});
				})
				.then(function setUIStatusValues() {
					if (vm.documentContentStatusValue.length > 0 && vm.documentContentStatusValue[0].length !== 0) {
						//vm.status = JSON.stringify({ Label: vm.documentContentStatusValue[0], StatusType: 'Content Status' });
						vm.status = { Label: vm.documentContentStatusValue[0], StatusType: 'Content Status' };
						vm.isContentStatusSelected = true;
					}

					if (vm.documentToDoStatusValue.length > 0 && vm.documentToDoStatusValue[0].length !== 0) {
						//vm.status = JSON.stringify({Label: vm.documentToDoStatusValue[0], StatusType: 'ToDo Status
						vm.status = {Label: vm.documentToDoStatusValue[0], StatusType: 'ToDo Status'};
						vm.isContentStatusSelected = false;
					}

					if (vm.documentAssignedUserId && vm.documentAssignedUserId[0] > 0) {
						vm.assignedUser = vm.users.filter(function(u) {
							return u.UserId === JSON.parse(vm.documentAssignedUserId[0]);
						});
						//vm.assignedUser = JSON.stringify(vm.assignedUser[0]);
						vm.assignedUser = vm.assignedUser[0];
					}
				})
				.finally(function () {
					//hide tiles till loaded
					$timeout(function () { vm.loading = false; }, 50);
				});
				
		}());
		vm.loading = true;
		vm.documentContentStatusValue = null;
		vm.documentToDoStatusValue = null;
		vm.documentAssignedUserId = null;
		vm.documentAssignedDate = null;

		vm.contentStatuses = [];
		vm.todoStatuses = [];
		vm.users = [];
		vm.statusIsDirty = false;

		vm.contentStatusTagTypeId = null;
		vm.todoStatusTagTypeId = null;
		vm.assignedUserIdTagTypeId = null;
		vm.assignedDateTagTypeId = null;

		vm.onChange = onChange;
		vm.saveStatus = saveStatus;
		vm.changeStatus = changeStatus;
		vm.changeAssingedUser = changeAssingedUser;
		vm.deleteDocument = deleteDocument;

		vm.isContentStatusSelected = false;

		function changeStatus(event) {
			var status = vm.todoStatuses.concat(vm.contentStatuses);
			//select current status
			status = status.map(function (s) {
				if (vm.status && (s.Label === vm.status.Label && s.StatusType === vm.status.StatusType)) {
					s.selected = true;
				}
				else {
					s.selected = false;
				}
				return s;
			});

			$mdDialog.show({
				controller: 'smbUserSelectorController',
				controllerAs: 'vm',
				templateUrl: userSelectorTemplateUrl,
				targetEvent: event,
				clickOutsideToClose: true,
				locals: {
					users: status,
					multiSelect: false
				}
			})
			.then(function (selectedStatus) {
				//new user groups
				if (selectedStatus.length === 1) {
					vm.status = selectedStatus[0];
					onChange();
					vm.saveStatus();
				}
			}, function () {
				//cancel
			});
		}
		function changeAssingedUser(event) {
			var users = vm.users;
			//select current assigned user
			if (vm.assignedUser) {
				users = users.map(function (user) {
					if (user.UserId === vm.assignedUser.UserId) {
						user.selected = true;
					}
					else {
						user.selected = false;
					}
					return user;
				});
			}

			$mdDialog.show({
				controller: 'smbUserSelectorController',
				controllerAs: 'vm',
				templateUrl: userSelectorTemplateUrl,
				targetEvent: event,
				clickOutsideToClose: true,
				locals: {
					users: users,
					multiSelect: false
				}
			})
			.then(function (selectedUser) {
				//new user groups
				if (selectedUser.length === 1) {
					vm.assignedUser = selectedUser[0];
					onChange();
					vm.saveStatus();
				}
			}, function () {
				//cancel
			});
		}

		function onChange() {

			var Status = vm.status;
			vm.statusIsDirty = false;
			if (Status && Status.StatusType === 'Content Status') {
				vm.isContentStatusSelected = true;
				vm.statusIsDirty = true;
			}
			else if (Status && Status.StatusType === 'ToDo Status') {
				var AssignedUser = vm.assignedUser;
				vm.isContentStatusSelected = false;
				if (AssignedUser && AssignedUser.UserId > 0) {
					vm.statusIsDirty = true;
				}
			}
		}

		function saveStatus() {
			var parsedStatus = vm.status;
			var parsedUser = vm.assignedUser;

			var contentstatus = {};
			contentstatus.TagTypeId = vm.contentStatusTagTypeId;
			contentstatus.Value = parsedStatus.StatusType === 'Content Status' ? parsedStatus.Label : null;

			var todostatus = {};
			todostatus.TagTypeId = vm.todoStatusTagTypeId;
			todostatus.Value = parsedStatus.StatusType === 'ToDo Status' ? parsedStatus.Label : null;

			var assigneduserid = {};
			assigneduserid.TagTypeId = vm.assignedUserIdTagTypeId;
			assigneduserid.Value = parsedStatus.StatusType === 'ToDo Status' && parsedUser ? parsedUser.UserId : 0;

			var assigneddate = {};
			assigneddate.TagTypeId = vm.assignedDateTagTypeId;
			var date = new Date();
			var mm = date.getMonth() + 1;
			if (mm < 10) {
				mm = '0' + mm;
			}
			var dd = date.getDate();
			if (dd < 10) {
				dd = '0' + dd;
			}
			assigneddate.Value = [mm, dd, date.getFullYear()].join('');

			var Status = [];
			Status.push(contentstatus);
			Status.push(todostatus);
			Status.push(assigneduserid);
			Status.push(assigneddate);

			smbStatusDataStore.setDocumentStatus(Status, vm.documentId).then(submitSuccess, submitFailure);
			return;
		}

		function submitSuccess(response) {
			if (response.Error) {
				submitFailure(response.Error);
				return;
			}
			vm.statusIsDirty = false;
			vm.toDoListDS.loadCount();
		}

		function submitFailure(e) {
			//failure
			console.log(e.data.Message);
		}

		function deleteDocument(event) {
			var title = gettextCatalog.getString('Delete Document');
			var message = gettextCatalog.getString('Would you like to delete this document?');
			var purgeText = gettextCatalog.getString('Selecting this checkbox will enable permanent deletion of this document that can\'t be undone!');

			smbDeleteDialogService
				.show(event, title, message, pxAuthService.isSiteAdmin, purgeText)
				.then(function(purge) {
					return smbDocumentDataStore
						.delete(purge)
						.then(function() {
							return $q.all([
								sbToastService.showSimple(gettextCatalog.getString('Document deleted')),
								smbDocumentViewerNavigationService.back()
							]);
						})
						.catch(function() {
							sbToastService.showSimple(gettextCatalog.getString('Unable to delete document'));
						});				
				}, angular.noop);
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/documentContextMenu/documentContextMenu.js
// module id = 79
// module chunks = 1